export const TableSortDirection = {
  DESCENDING: 'descending',
  ASCENDING: 'ascending'
};
export const TABLE_HEAD_CELL_ALIGN_TO_JUSTIFY_CONTENT = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end'
};